import { Flex, HStack, IconButton, Text, Spacer, Icon, VStack } from '@chakra-ui/react';

import { IoRemoveCircleOutline, IoStar } from 'react-icons/io5';

type CouponInfoBarProps = {
  value: string;
  onClick?: () => void;
};

export default function CouponInfoBar({ value, onClick }: CouponInfoBarProps) {
  return (
    <VStack align="stretch">
      <Text fontSize="sm" fontWeight="bold">
        已使用優惠券
      </Text>
      <Flex p={2} align="center" bgColor="gray.200" borderRadius="5px">
        <HStack align="flex-start">
          <Icon as={IoStar} boxSize="1.25rem" />
          <Text fontSize="sm">{value}</Text>
        </HStack>
        <Spacer />
        <IconButton
          aria-label="remove coupon"
          variant="unstyled"
          size="md"
          icon={
            <Icon
              as={IoRemoveCircleOutline}
              boxSize="1.5rem"
              color="danger.600"
              onClick={onClick}
            />
          }
        />
      </Flex>
    </VStack>
  );
}
